/*
 * File: addresses.d.ts
 * Project: rosita
 * -----
 * Last Modified: 25 Feb 2022 12:09:03 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Business } from 'models/Business';
import { Contact } from 'models/Contact';

export interface Address {
  addressType: 'Delivery';
  business: Business;
  city: string;
  code: string;
  contact: Contact;
  country: {
    alpha2Code: string;
    alpha3Code: string;
    fullName: string;
    shortName: string;
  };
  county: string;
  createdByFullName: string;
  createdByUserId: string;
  createdDateTime: string;
  documentType: string;
  id: string;
  isActive: boolean;
  isDeleted: boolean;
  isVerifiedByGoogle: boolean;
  latitude: number;
  longitude: number;
  modifiedByFullName: string;
  modifiedByUserId: string;
  modifiedDateTime: string;
  name: string;
  partitionKey: string;
  partitionKeyDescription: string;
  postalCode: string;
  street1: string;
  street2: null | string;
  subdivision: {
    categoryName: string;
    code: string;
    localCode: string;
    name: string;
  };
}

export enum LocationAddressTypes {
  Install = 'Install',
  Delivery = 'Delivery',
  Warehouse = 'Warehouse'
}

export interface GetAddressesResponse {
  totalCount: number;
  data: Address[];
}

export interface GetAddressesParams {
  offset: number;
  orderByField?: string;
  orderByDirection?: string;
  addressCodeContains?: string;
  addressNameContains?: string;
  addressTypesInclude?: LocationAddressTypes[];
  street1Contains?: string;
  cityContains?: string;
  countyContains?: string;
  countryAlpha2CodeEquals?: string;
  subdivisionLocalCodeEquals?: string;
  postalCodeContains?: string;
  warehouseTypeEquals?: string;
  overrideSkipTake?: boolean;
}
